var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var pickerRequestState = require('../layout/components/pickerRequestState');
var verticalListItem = require('../components/verticalListItem');
var paginationWithSearch = require('../data/components/paginationWithSearch');

var trees = {};

trees.oninit = function (vnode) {
  var ctrl = this;
  ctrl.startView = false;
  ctrl.selectedNode = vnode.attrs.selectedNode;
  ctrl.newNode = prop();
  ctrl.dataToShow = [];
  pickerRequestState.initialize(ctrl);

  ctrl.getLocations = function () {
    ctrl.actualLevel = prop('Home');
    ctrl.ancestors = prop([{ '@class': 'Home', 'name': 'Home' }]);
    ctrl.selectedNode('');  
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/',
        method: 'GET'
      })
      .then(function (result) {
        ctrl.locations = result.out_Contains && Array.isArray(result.out_Contains) ? result.out_Contains.filter(c => c.in['@class'] == 'Site').map(r=> r.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: ctrl.getLocations, errorMessage: 'Unable to load locations for picker:' });
  }

  ctrl.navigateLocation = function (location) {
    ctrl.startView = false;
    ctrl.actualLevel('Site');
    ctrl.ancestors([ctrl.ancestors()[0], location]);
    ctrl.selectedNode('');
    
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + location['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.buildings = res.out_isSiteOf && Array.isArray(res.out_isSiteOf) ? res.out_isSiteOf.map(isSiteOfEdge => isSiteOfEdge.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateLocation(location); }, errorMessage: 'Unable to load location children for picker:' });
  }
  ctrl.selectNode = function (node) {
    ctrl.selectedNode(node)
  }

  ctrl.navigateBuilding = function (building) {
    ctrl.startView = false;
    ctrl.actualLevel('Building');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], building]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + building['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.floors = res.out_hasPart && Array.isArray(res.out_hasPart) ? res.out_hasPart.map(out_hasPartEdge => out_hasPartEdge.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateBuilding(building); }, errorMessage: 'Unable to load building children for picker:' });
  }
  
  ctrl.navigateLevel = function (level) {
    ctrl.startView = false;
    ctrl.actualLevel('Level');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], ctrl.ancestors()[2], level]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + level['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.rooms = res.out_hasPart && Array.isArray(res.out_hasPart) ? res.out_hasPart.map(out_hasPartEdge => out_hasPartEdge.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateLevel(level); }, errorMessage: 'Unable to load level children for picker:' });
  }
  ctrl.selectNode = function (node) {
    ctrl.selectedNode(node)
  }
  ctrl.getLocations();
}

trees.view = function () {
  var ctrl = this;
  var stateView = pickerRequestState.view(ctrl);
  if (stateView) return stateView;
  if (!ctrl.startView) return m('div')

  return m('div.mb2', [
    m('label', 'Select location:'),
    m('br'),
    m("div.mb2.pb2.bb.bw1.b--mid-gray.near-white", [
      m('div.dib-ns.mr2', { label: 'Home', onclick: ctrl.getLocations }),
      function () {
        if (ctrl.ancestors) {
          return ctrl.ancestors().map(function (ancestor, idx) {
            return m('div.dib-ns.mr2.pointer', {
              class: ancestor['@class'] === ctrl.actualLevel() ? "active" : "blue",
              onclick: () => {
                if (ancestor['@class'] === 'Home') ctrl.getLocations();
                if (ancestor['@class'] === 'Site') ctrl.navigateLocation(ancestor);
                if (ancestor['@class'] === 'Building') ctrl.navigateBuilding(ancestor);
              }
            }, [
              ancestor.name,
              ' / '
            ])
          })
        }
      }()
    ]),
    (() => {
      if (ctrl.actualLevel() === 'Home') {
        return m(paginationWithSearch, {
          data: ctrl.locations,
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((location, idx) => {
            if(!location['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                location.name,
                Array.isArray(location.out_isSiteOf) && location.out_isSiteOf.length > 0 ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                Array.isArray(location.out_isSiteOf) && location.out_isSiteOf.length > 0 ?
                  ctrl.navigateLocation(location)
                : 
                  ctrl.selectNode(location)
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(location) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == location['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ]
            )
          })
        ])
      }
      if (ctrl.actualLevel() === 'Site') {
        return m(paginationWithSearch, {
          data: ctrl.buildings,
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((building, idx) => {
            if(!building['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                building.name,
                Array.isArray(building.out_hasPart) && building.out_hasPart.length > 0 ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                Array.isArray(building.out_hasPart) && building.out_hasPart.length > 0 ?
                  ctrl.navigateBuilding(building)
                :
                  ctrl.selectNode(building)
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(building) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == building['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Building') {
        return m(paginationWithSearch, {
          data: ctrl.floors,
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((floor, idx) => {
            if(!floor['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                floor.name,
                Array.isArray(floor.out_hasPart) && floor.out_hasPart.length > 0 ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                Array.isArray(floor.out_hasPart) && floor.out_hasPart.length > 0 ?
                  ctrl.navigateLevel(floor)
                :
                  ctrl.selectNode(floor)
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(floor) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == floor['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Level') {
        return m(paginationWithSearch, {
          data: ctrl.rooms,
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((room, idx) => {
            if(!room['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                room.name
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                ctrl.selectNode(room)
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(room) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == room['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
    })(),
  ])
}

module.exports = trees;
